import React from 'react'
import { Button } from '../ui/button'
import { EmptyStateText, EmptyStateDiv } from './styled'
import { Text1, Text2 } from '../ui/text'
import { SadFace } from '../../assets/icons'
import colors from '../../styles/colors'

const EmptyState = ({ actionButton = true, isSearch, title, subtitle }) => {
	const emptyContent = isSearch && !actionButton
		? {
			icon: <SadFace />,
			title: title || 'No tenemos resultados para vos',
			subtitle: subtitle || 'Por favor, volvé a intentar con una nueva búsqueda.',
			action: null
		}
		: isSearch && actionButton
			? {
				icon: <SadFace />,
				title: title || 'No tenemos resultados para vos',
				subtitle: subtitle || 'Por favor, volvé a intentar con una nueva búsqueda.',
			action: (
				<Button label="Ver todos los resultados" $variant="primary" onClick={actionButton} />
			)
			}
		: {
			icon: <SadFace />,
			title: title || 'No tenés resultados',
			subtitle: subtitle || 'Cuando tengas alguno, lo vas a ver acá.',
			action: null
		}
	return (
		<EmptyStateDiv>
			{emptyContent.icon}
			<EmptyStateText>
				<Text1 color={colors.text.primaryText}>{emptyContent.title}</Text1>
				<Text2 color={colors.text.secondaryText}>{emptyContent.subtitle}</Text2>
			</EmptyStateText>
			{emptyContent.action}
		</EmptyStateDiv>
	)
}

export default EmptyState
